var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import A2HSContext, { initialState } from './themeContext';

var A2HSProvider = function (_Component) {
  _inherits(A2HSProvider, _Component);

  function A2HSProvider() {
    var _temp, _this, _ret;

    _classCallCheck(this, A2HSProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.setA2HPState = function (newState) {
      _this.setState(_extends({}, newState));
    }, _this.state = _extends({}, initialState, {
      setA2HPSState: _this.setA2HPState
    }), _temp), _possibleConstructorReturn(_this, _ret);
  }

  A2HSProvider.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    window.addEventListener('beforeinstallprompt', function (e) {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      e.preventDefault();
      // Stash the event so it can be triggered later.
      _this2.setState({ deferredPrompt: e, isAppInstallable: true });
      console.log('deffered prompt saved');
    });

    window.addEventListener('appinstalled', function (evt) {
      _this2.setState({ isAppInstalled: true });
    });
  };

  A2HSProvider.prototype.render = function render() {
    return React.createElement(
      A2HSContext.Provider,
      { value: this.state },
      this.props.children
    );
  };

  return A2HSProvider;
}(Component);

export default A2HSProvider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/a2hs/es/A2HSProvider.js
// module id = 163
// module chunks = 28